// src/services/cacheCidades.js
export const CIDADES_CACHE_TTL_MS = 10 * 60 * 1000;
export const cachedCidades = [];

let cachedCidadesRequest = null;
let cachedCidadesUpdatedAt = 0;

export function isCachedCidadesValid(ttlMs = CIDADES_CACHE_TTL_MS) {
  return (
    cachedCidades.length > 0 &&
    cachedCidadesUpdatedAt > 0 &&
    Date.now() - cachedCidadesUpdatedAt < ttlMs
  );
}

export function clearCachedCidades() {
  cachedCidades.splice(0, cachedCidades.length);
  cachedCidadesUpdatedAt = 0;
  cachedCidadesRequest = null;
}

export function loadCachedCidades(fetcher, options = {}) {
  const { force = false, ttlMs = CIDADES_CACHE_TTL_MS } = options;

  if (!force && isCachedCidadesValid(ttlMs)) {
    return Promise.resolve(cachedCidades);
  }

  if (cachedCidadesRequest) {
    return cachedCidadesRequest;
  }

  cachedCidadesRequest = fetcher()
    .then((response) => {
      const cidades = Array.isArray(response?.data) ? response.data : [];
      cachedCidades.splice(0, cachedCidades.length, ...cidades);
      cachedCidadesUpdatedAt = Date.now();
      return cachedCidades;
    })
    .finally(() => {
      cachedCidadesRequest = null;
    });

  return cachedCidadesRequest;
}
